import React, { FunctionComponent } from "react";

import { MenuComponent } from "../MenuComponent";
import { QuickAccessContent } from "../QuickAccessContent";
import { QuickAccessMenuHeader } from "../QuickAccessMenuHeader";
import { QuickAccessSearchResults } from "../QuickAccessSearchResults";
import { QuickAccessMenuComponentProps } from "./QuickAccessMenuComponentProps";

export { QuickAccessMenuComponentProps };

export const QuickAccessMenuComponent: FunctionComponent<QuickAccessMenuComponentProps> = ({ isSearchActive }) => (
    isSearchActive ? (
        <MenuComponent
            isPlain={true}
        >
            <QuickAccessSearchResults />
        </MenuComponent>
    ) : (
        <MenuComponent
            headerContent={<QuickAccessMenuHeader />}
        >
            <QuickAccessContent />
        </MenuComponent>
    )
);
